import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

@Component({
    selector: 'app-truck-registration-masterdata',
    templateUrl: './truck-registration-masterdata.component.html',
    styleUrls: ['./truck-registration-masterdata.component.scss'],
    standalone: false
})
export class TruckRegistrationMasterdataComponent extends AbstractWidgetComponent implements OnInit {

  masterdataForm = new FormGroup({});

  constructor(
    public translationService: TranslationService
  ) {
    super();

    this.masterdataForm.addControl('carrier', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('supplier', new FormControl(null, []));
    this.masterdataForm.addControl('driver', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('coDriver', new FormControl(null, []));
    this.masterdataForm.addControl('numberplate', new FormControl(null, [Validators.required]));

    this.masterdataForm.valueChanges.subscribe(
      value => {
        this.dashboardContext.setContextValue(TerminalContextConstants.carrier, this.masterdataForm.controls.carrier.value);
        this.dashboardContext.setContextValue(TerminalContextConstants.supplier, this.masterdataForm.controls.supplier.value);
        this.dashboardContext.setContextValue(TerminalContextConstants.driver, this.masterdataForm.controls.driver.value);
        this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, this.masterdataForm.controls.coDriver.value);
        this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, this.masterdataForm.controls.numberplate.value);
        this.dashboardContext.setContextValue(TerminalContextConstants.truckMasterdataValidityState, this.masterdataForm.valid);
      }
    );
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) { }

  onSetElementAndContext() {

    const values: any = {};
    values.carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
    values.supplier = this.dashboardContext.getContextValue(TerminalContextConstants.supplier);
    values.driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
    values.coDriver = this.dashboardContext.getContextValue(TerminalContextConstants.coDriver);
    values.numberplate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);

    this.masterdataForm.reset(values);
    this.dashboardContext.setContextValue(TerminalContextConstants.truckMasterdataValidityState, this.masterdataForm.valid);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
